import { appEnv } from './env'
import { getSupabase } from './supabase'

/**
 * Login direto no GoTrue local — sem spa-bridge, sem dev01.
 *
 * Só com `VITE_AUTH_MODE=local` (e o env.ts recusa isso em build de produção).
 * Os usuários de teste vêm do `supabase/seed.sql`; a senha, do `.env.local`.
 */

/** Perfis do seed — trocar de perfil é como se confere a matriz de permissão. */
export const DEV_PROFILES = [
  { email: 'gestor@supply.local', label: 'Marciel — gestor' },
  { email: 'erick@supply.local', label: 'Erick — responsável de COMPRAS' },
  { email: 'mateus@supply.local', label: 'Mateus — responsável de PCP/ENG' },
  { email: 'maria@supply.local', label: 'Maria — executora de PCP/ENG (time do Mateus)' },
  { email: 'jhonatan@supply.local', label: 'Jhonatan — responsável de ESTOQUE' },
  { email: 'ana@supply.local', label: 'Ana — executora de COMPRAS (time do Erick)' },
  { email: 'bruno@supply.local', label: 'Bruno — executor de COMPRAS (time do Erick)' },
  { email: 'carla@supply.local', label: 'Carla — executora de ESTOQUE (time do Jhonatan)' },
  { email: 'semvinculo@supply.local', label: 'Usuário do SSO sem acesso' },
  { email: 'admin@supply.local', label: 'Dev admin — fantasma (vê tudo, ninguém o vê)' },
] as const

export async function currentDevUserId(): Promise<string | null> {
  const { data } = await getSupabase().auth.getSession()
  return data.session?.user?.id ?? null
}

export async function devSignIn(email: string): Promise<string> {
  if (!appEnv.devPassword) {
    throw new Error('Defina VITE_DEV_SUPABASE_PASSWORD no apps/web/.env.local.')
  }
  const { data, error } = await getSupabase().auth.signInWithPassword({ email, password: appEnv.devPassword })
  if (error) throw new Error(`Login local falhou: ${error.message}`)
  if (!data.user) throw new Error('Login local não devolveu usuário')
  return data.user.id
}

export async function devSignOut(): Promise<void> {
  await getSupabase().auth.signOut()
}
